<template>
  <sui-accordion exclusive>
                    <div v-for="item in permissions" :key="item.app" class="mb-20">
                        <sui-accordion-title active>
                            <h4 class="ui blue header">
                                <sui-icon name="dropdown" /> {{ item.app }} ({{getActivePermissions(item)}}/{{item.permissions.length || 0}})
                            </h4>
                        </sui-accordion-title>
                        <sui-accordion-content active>
                            <sui-list>
                                <a is="sui-list-item" v-for="permission in item.permissions" :key="permission.id">
                                    <sui-checkbox :label="permission.description" v-model="permission.active" />
                                </a>
                            </sui-list>
                        </sui-accordion-content>
                    </div>
                </sui-accordion>
</template>

<script>
import PermissionService from '@/services/PermissionService'
import Utils from '@/common/Utils'

export default {
    name: 'Permission',
    props: ['user'],
    async beforeMount () {
        this.loader = this.$loading.show()
        this.getPermissions()
    },
    data () {
        return {
            permissions: [],
            loader: undefined
        }
    },
    methods: {
        async getPermissions () {
            try {
                let { data } = await PermissionService.getAll({})
                this.permissions = Utils.getOrderedPermissions(data)
                this.setPermissions()
                this.loader.hide()
            } catch (error) {
                console.error(error)
                this.$swal({
                    title: error.message,
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonText: 'Volver al listado',
                    confirmButtonColor: '#2BBA45',
                    showCloseButton: false
                })
            }
        },
        setPermissions () {
            for (let perm of this.permissions) {
                for (let permission of perm.permissions) {
                    if (this.user.permission.includes(permission.id)) {
                        permission.active = true
                    }
                }
            }
        },

        getActivePermissions (item) {
            return item.permissions.filter(m => m.active).length || 0
        }
    },
    watch: {
        permissionsToSave () {
            this.$emit('setPermissions', this.permissionsToSave)
        }
    },
    computed: {
        permissionsToSave () {
            let permissions = []
            for (let item of this.permissions) {
                let childs = item.permissions.filter(m => m.active).map(m => { return m.id })
                permissions = permissions.concat(childs)
            }
            return permissions
        }
    }
}
</script>

<style>

</style>
